import React from 'react';
import Form from 'react-bootstrap/Form';

import Util from '../../../util/Util';
import Const from '../../../util/Constants';

class AutomationModel extends React.Component {

  constructor(props) {
    super(props);
    this.state = { model: '', permission: [ false, false, false, false, false, false, false ], ...props.value };

    const binary = Util.decimalToBinary(this.state.action);
    for(let j = binary.length - 1, i = 0; j >= 0 ; j--, i++) {
      this.state.permission[i] = parseInt(binary[j]) === Const.True;
    }
  }

  UNSAFE_componentWillReceiveProps(props) {
    const permission = [ ...this.state.permission ];
    const binary = Util.decimalToBinary(props.value.action);
    for(let j = binary.length - 1, i = 0; j >= 0 ; j--, i++) {
      permission[i] = parseInt(binary[j]) === Const.True;
    }
    this.setState({ ...this.state, ...props.value, permission }); 
  }

  onChange = (field, val) => {
    const state = { ...this.state };
    state[field] = val;
    this.props.onModelChange(state);
    this.setState({ ...state });
  }

  onPermissionChange = (val, index) => {
    const permission = [ ...this.state.permission ];
    permission[index] = val;
    let binary = '';
    for(let i = permission.length -1; i >= 0 ; i--) {
      binary += permission[i] ? Const.True : Const.False;
    }
    const state = { ...this.state };
    state.action = Util.binaryToDecimal(binary);
    this.props.onActionChange(state.action);
    this.setState({ ...this.state, action: state.action, permission: permission });
  }

  render() {
    return (
      <div className="col-md-12">
        <div className="form-group col-md-12">
          <Form.Check>
            <Form.Check.Input type="radio" checked={this.state.model === 'lead'} onChange={() => this.onChange('model', 'lead')} />
            <Form.Check.Label>Lead</Form.Check.Label>
          </Form.Check>
          <Form.Check>
            <Form.Check.Input type="radio" checked={this.state.model === 'sales_order'}
              onChange={event => this.onChange('model', 'sales_order')} />
            <Form.Check.Label>Sales Order</Form.Check.Label>
          </Form.Check>
          <Form.Check>
            <Form.Check.Input type="radio" checked={this.state.model === 'installment'}
              onChange={event => this.onChange('model', 'installment')} />
            <Form.Check.Label>Installment</Form.Check.Label>
          </Form.Check>
          <Form.Check>
            <Form.Check.Input type="radio" checked={this.state.model === 'call'}
              onChange={event => this.onChange('model', 'call')} />
            <Form.Check.Label>Call</Form.Check.Label>
          </Form.Check>
          <Form.Check>
            <Form.Check.Input type="radio" checked={this.state.model === 'meeting'}
              onChange={event => this.onChange('model', 'meeting')} />
            <Form.Check.Label>Meeting</Form.Check.Label>
          </Form.Check>
          <Form.Check>
            <Form.Check.Input type="radio" checked={this.state.model === 'note'}
              onChange={event => this.onChange('model', 'note')} />
            <Form.Check.Label>Note</Form.Check.Label>
          </Form.Check>
        </div>
        <div className="formhead col-md-12 p-0"><h4>Action</h4></div>
        <div className="form-group col-md-12">
          <Form.Check>
            <Form.Check.Input type="checkbox"
              onChange={ event => this.onPermissionChange(event.target.checked, Const.PermView) }
              checked={this.state.permission[Const.PermView]} />
            <Form.Check.Label>Preview / Details</Form.Check.Label>
          </Form.Check>
          <Form.Check>
            <Form.Check.Input type="checkbox" 
              onChange={ event => this.onPermissionChange(event.target.checked, Const.PermUpdate) }
              checked={this.state.permission[Const.PermUpdate]} />
            <Form.Check.Label>Update / Edit</Form.Check.Label>
          </Form.Check>
          <Form.Check>
            <Form.Check.Input type="checkbox" 
              onChange={ event => this.onPermissionChange(event.target.checked, Const.PermDelete) }
              checked={this.state.permission[Const.PermDelete]} />
            <Form.Check.Label>Delete</Form.Check.Label>
          </Form.Check>
        </div>
      </div>
    );
  }
}
export default AutomationModel;
